import React from "react";
import { Grid } from "@material-ui/core";
import CustomModal from "../../../components/common/customModal";
import FileUpload from "../../../components/common/fileUpload";
import CustomSelect from "../../../components/common/customSelect";
import LogoUpload from "../../../components/common/logoUpload";

interface AllTheHelpYouNeedModalProps {
  open: boolean;
  onClose: () => void;
  onSave: () => void;
}

const AllTheHelpYouNeedModal: React.FC<AllTheHelpYouNeedModalProps> = ({
  open,
  onClose,
  onSave,
}) => {
  return (
    <CustomModal
      open={open}
      handleClose={onClose}
      onSave={onSave}
      saveTitle="Submit"
      title="REImagine"
      width={700}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <CustomSelect
            name="allTheHelp "
            label="All the help you need"
            placeHolder="Select"
            value=""
            onChange={() => {}}
            options={[
              { label: "Option 1", value: "option1" },
              { label: "Option 2", value: "option2" },
            ]}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <LogoUpload label="Upload Logo" onChange={() => {}}></LogoUpload>
        </Grid>

        <Grid item xs={12} md={12}>
          <FileUpload fileTypeLabel="video" onChange={() => {}} />
        </Grid>
      </Grid>
    </CustomModal>
  );
};

export default AllTheHelpYouNeedModal;
